import { render } from "./ProfileCollection.vue?vue&type=template&id=79a844aa"
import script from "./ProfileCollection.vue?vue&type=script&lang=js"
export * from "./ProfileCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__